import * as types from '../constants/ActionTypes';
import client from '../lib/frost-web-client';
import logout from '../lib/logout';
import { receiveCorp, resolveEditCorporation } from './corporations';
import { receiveSubdivisionList } from './subdivisions';

//BUILDERS
export function requestBuilderList() {
	return { type: types.REQUEST_BUILDER_LIST };
}

export function receiveBuilderList(list) {
	return { type: types.RECEIVE_BUILDER_LIST, list };
}

export function receiveBuilderListError(error) {
	return { type: types.RECEIVE_BUILDER_LIST_ERROR, error };
}

export function fetchBuilderList(params) {
	return dispatch => {

		dispatch(requestBuilderList());

		return client.get('/api/builders', params)
			.then(response => dispatch(receiveBuilderList(response.body)))
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveBuilderListError(error.response));
				}
			});
	};
}

//BUILDER GET
export function requestBuilder() {
	return { type: types.REQUEST_BUILDER };
}
//AKA SELECT BUILDER
export function receiveBuilder(builder) {
	return { type: types.RECEIVE_BUILDER, builder };
}

export function receiveBuilderError(error) {
	return { type: types.RECEIVE_BUILDER_ERROR, error };
}

export function fetchBuilder(builderId, params = {}) {
	return dispatch => {

		dispatch(requestBuilder());

		return client.get(`/api/builders/${builderId}`, params)
			.then(response => {

				dispatch(receiveBuilder(response.body));

				// Set the corporation if it exists in the response
				if (response.body.corporation) {
					dispatch(receiveCorp(response.body.corporation));
				}

			})
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(receiveBuilderError(error.response));
				}
			});
	};
}

//BUILDER EDIT
export function submitEditBuilder() {
	return { type: types.SUBMIT_EDIT_BUILDER };
}

export function resolveEditBuilder(builder) {
	let success = {
		message: 'Builder edited.'
	}
	return { type: types.RESOLVE_EDIT_BUILDER, success, builder };
}

export function resolveEditBuilderError(error) {
	return { type: types.RESOLVE_EDIT_BUILDER_ERROR, error };
}

export function editBuilder(builder) {
	return dispatch => {

		dispatch(submitEditBuilder());

		return client.put('/api/builders/' + builder.id, builder)
			.then(response => {
				dispatch(resolveEditBuilder(response.body));

				// If the builder's customer ID was set to a non-null value
				// then set the parent corporation's customer ID to null.
				if (builder.corporationId && builder.customerId) {
					dispatch(resolveEditCorporation({
						id: builder.corporationId,
						customerId: null,
					}));
				}
			})
			.catch(error => {
				if (!logout(error, dispatch)) {
					dispatch(resolveEditBuilderError(error.response));
				}
			});
	};
}

//BUILDER PAGE
export function requestBuilderPage() {
	return { type: types.REQUEST_BUILDER_PAGE };
}

export function receiveBuilderPageError(error) {
	return { type: types.RECEIVE_BUILDER_PAGE_ERROR, error };
}

export function getBuilderPage(builderId, params = {}) {
	return dispatch => {

		dispatch(requestBuilderPage());

		return client.get(`/api/builders/${builderId}/page`, params)
			.then(response => {

				// Set the subdivision list
				dispatch(receiveSubdivisionList(response.subdivisions));

				// Set the builder and corporation, if returned
				if (response.builder) {
					dispatch(receiveBuilder(response.builder));
				}
				if (response.corporation) {
					dispatch(receiveCorporation(response.corporation));
				}

			})
			.catch(error => !logout(error, dispatch) ? dispatch(receiveBuilderPageError(error.response)) : null);
	};
}


// WEBPACK FOOTER //
// ./src/assets/js/actions/builders.js